let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g10ml")).then(() => parcelRequire('bmf4G'));